(function ($) {
  merchWindowPairFormatterV1 = {
    formatter: $('.merch-window-pair-formatter-v1')
  };

  Drupal.behaviors.merchWindowPairFormatterV1 = {
    get: function (key) {
      return merchWindowPairFormatterV1[key];
    },

    set: function (key, val) {
      merchWindowPairFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // grab all primary nodes, add item number, wrap, and move container
        thisFormatter.find('.primary-node')
          .each(function (i) {
            $(this).attr('item', i);
          })
          .wrapAll('<div class="primary-nodes" />')
          .parent()
          .appendTo(thisFormatter);

        // grab all related nodes, add item number, wrap, and move container
        thisFormatter.find('.related-node')
          .each(function (i) {
            $(this).attr('item', i);
          })
          .wrapAll('<div class="related-nodes" />')
          .parent()
          .appendTo(thisFormatter);

        // cleanup empty containers
        thisFormatter.find('.merch-window-pair-v1').each(function () {
          $(this).remove();
        });

        // build arrow navigation
        thisFormatter.find('.primary-nodes').prepend('<ul class="flex-direction-nav"><li><a href="#" class="flex-prev">Previous</a></li><li><a href="#" class="flex-next">Next</a></li></ul>');
        var arrowNav = thisFormatter.find('.flex-direction-nav');

        // build dot navigation
        thisFormatter.find('.primary-nodes').prepend('<ol class="flex-control-nav flex-control-paging"></ol>');
        var dotNav = thisFormatter.find('.flex-control-nav');

        thisFormatter.find('.primary-node').each(function (i) {
          dotNav.append('<li><a item="' + i + '">' + i + '</a></li>');
        });

        // New header slider tabs
        var triggerDiv = thisFormatter.find('.slider-trigger');

        triggerDiv.find('.item').hide();
        triggerDiv.find('.container').prepend('<ol class="flex-control-nav flex-control-paging"></ol>');
        var topNav = triggerDiv.find('.flex-control-nav');
        var anchor = triggerDiv.find('a');

        anchor.each(function (i) {
          var a = $(this);
          var item = a.attr('item');
          var img = a.find('img').attr('src');

          topNav.append('<li><a item="' + item + '"><img src="' + img + '" alt="" /></a></li>');
          $(document).ready(function () {
            topNav.find('a').each(function (j) {
              var self = $(this);
              var index = self.attr('item');
              var cushion = 0;
              var liItems = triggerDiv.find('.flex-control-nav.flex-control-paging li');
              var img = new Image();

              img.onload = function () {
                self.closest('.flex-control-nav.flex-control-paging').css({
                  'float': 'right',
                  'height': this.height + 'px',
                  'overflow': 'hidden',
                  'width': (this.width * liItems.length + cushion) + 'px'
                });
                self.parent().css({
                  'float': 'left',
                  'margin': '0',
                  'width': this.width + 'px'
                });
                self.find('img').css({
                  'display': 'block',
                  'height': this.height + 'px',
                  'width': this.width + 'px'
                });
                // Mobile
                if (thisFormatter.closest('body').hasClass('device-mobile')) {
                  triggerDiv.css({ 'height': (self.find('img').height() / 2 + 10) + 'px' });
                  self.closest('.flex-control-nav.flex-control-paging').css({
                    'float': 'none',
                    'height': '40px',
                    'left': '0',
                    'top': '0',
                    'width': '100%'
                  });
                  self.parent().css({
                    'float': 'left',
                    'margin': '0',
                    'width': '33.3%'
                  });
                  self.find('img').css({
                    'display': 'block',
                    'height': 'auto',
                    'width': Math.round(triggerDiv.width() / 3) + 'px'
                  });
                }
              };
              img.src = self.find('img').attr('src');
              self.once().on('click', function() {
                var item = $(this).attr('item');
                var primaryNode = thisFormatter.find('.primary-nodes .primary-node');

                dotNav.find('a').removeClass('flex-active');
                primaryNode.removeClass('active');
                thisFormatter.find('.related-node').removeClass('active');
                thisFormatter.find('.primary-node[item="' + item + '"]').addClass('active');
                thisFormatter.find('.related-node[item="' + item + '"]').addClass('active');
                dotNav.find('a[item="' + item + '"]').addClass('flex-active');

                // Check for videos
                primaryNode.each(function () {
                  var thisNode = $(this);
                  var singleVideo = thisNode.find('.single-video');
                  var videoPlay = singleVideo.find('.video_player_button.play');

                  if (singleVideo.length > 0) {
                    if (videoPlay.hasClass('pause')) {
                    // Stop other slider's playing videos
                      singleVideo.find('video').trigger('click');
                    }
                  }
                });
              });
            });
          });
        });

        // active state
        dotNav.find('a').once().on('click', function() {
        // toggle visibility
          var item = $(this).attr('item');
          var primaryNode = thisFormatter.find('.primary-nodes .primary-node');

          dotNav.find('a').removeClass('flex-active');
          primaryNode.removeClass('active');
          thisFormatter.find('.related-node').removeClass('active');
          thisFormatter.find('.primary-node[item="' + item + '"]').addClass('active');
          thisFormatter.find('.related-node[item="' + item + '"]').addClass('active');
          dotNav.find('a[item="' + item + '"]').addClass('flex-active');

          // Check for videos
          primaryNode.each(function () {
            var thisNode = $(this);
            var singleVideo = thisNode.find('.single-video');
            var videoPlay = singleVideo.find('.video_player_button.play');

            if (singleVideo.length > 0) {
              if (videoPlay.hasClass('pause')) {
              // Stop other slider's playing videos
                singleVideo.find('video').trigger('click');
              }
            }
          });
        });

        // prev arrow
        arrowNav.find('.flex-prev').once().on('click', function() {
          var active = dotNav.find('.flex-active').parent();
          var prev = active.prev();

          if (!prev.length) {
            prev = dotNav.find('li').last();
          }
          prev.children().trigger('click');
          // Initialize hidden sliders
          $(window).trigger('resize');

          return false;
        });

        // next arrow
        arrowNav.find('.flex-next').once().on('click', function() {
          var active = dotNav.find('.flex-active').parent();
          var next = active.next();

          if (!next.length) {
            next = dotNav.find('li').first();
          }
          next.children().trigger('click');
          // Initialize hidden sliders
          $(window).trigger('resize');

          return false;
        });

        // detect page hash index number, show relevant merch windows
        var index = 0;
        var hash = window.location.hash;

        if (hash) {
          index = /\d+/.exec(hash)[0];
          index = parseInt(index) || 0;
          if (index > 0) {
            dotNav.find('a[item="' + index + '"]').trigger('click');
          }
        } else {
        // activate first merch window pair
          thisFormatter.find('.primary-node[item="0"]').addClass('active');
          thisFormatter.find('.related-node[item="0"]').addClass('active');
          dotNav.find('a[item="0"]').addClass('flex-active');
        }

        // Check for sliders and reset
        var relatedNodes = thisFormatter.find('.related-nodes');

        relatedNodes.each(function () {
          var thisNode = $(this);
          var prodContentCarousel = thisNode.find('.product-content-carousel-v1');

          if (prodContentCarousel) {
            var slider = prodContentCarousel.find('.flexslider');

            slider.addClass('merch-window-slider');
          } else {
            var slider = thisNode.find('.flexslider');
          }

          var flexArr = [];
          var flexId = slider.attr('id');

          if (flexArr.indexOf(flexId) == -1) {
          // default 3-column
            var itemMargin = 20;
            var itemWidth = 300;
            var visibleCols = 3;

            // 5-column
            if (prodContentCarousel.hasClass('columns-5')) {
              itemMargin = 12;
              itemWidth = 180;
              visibleCols = 5;
            }

            var slideshow = false;

            if (slider.hasClass('flexslider-slideshow')) {
              slideshow = true;
            }

            var flexsliderDir = slider.data('direction');
            var rtl = flexsliderDir && flexsliderDir == 'rtl' ? true : false;

            slider.each(function (i) {
              var thisSlider = $(this);
              var sliderItem = thisSlider.attr('data-item', 'item-' + i);

              thisSlider.flexslider({
                animation: 'slide',
                // animationLoop: true,
                itemMargin: itemMargin,
                itemWidth: itemWidth,
                // minItems: visibleCols,
                maxItems: visibleCols,
                move: visibleCols,
                slideshow: slideshow,
                rtl: rtl
              });
            });

            flexArr.push(flexId);
            slider.find('.slides > li').css({
              'min-width': itemWidth + 'px',
              'display': 'block'
            });
            slider.find('.flex-direction-nav a').css({ 'background-image': 'url("/media/export/cms/nav-arrows.png")' });
          }
        });
      });
    }
  };
})(jQuery);
